<template>
  <cTable
    ref="table"
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
    <template #header>
      <Tabs type="card" v-model="tabName" @on-click="handleTab">
        <TabPane
          v-for="(item, idx) in tabList"
          :key="idx"
          :label="item.label"
          :name="item.value"
        />
      </Tabs>
    </template>
  </cTable>
</template>

<script>
import {
  getBillForecastList,
  getConfig,
  getRemarkList,
  addRemark,
  delRemark,
  exportExcel,
  syncData
} from "@/api/forecastManagement/billForecast";
// import { getCountry } from "@/api/system/country";
// import { getSelectType } from "@/api/public";
// import { getUser } from "@/api/user/internal";
// import { getChannel } from "@/api/tracker/channel";
// import { getAgent } from "@/api/tracker/agent";
// import { getStatus } from "@/api/tracker/status";
// import { getAllClient } from "@/api/user/client";
// import { getUser } from "@/api/user/internal";
import cTable from "@/base/common/index";
import { getSelectType, getKeysType } from "@/api/public";
export default {
  name: "billForecast",
  components: {
    cTable
  },
  data() {
    let that = this;
    return {
      tabList: [],
      tabName: "KQ",
      statusId: "",
      setData: {},
      methods: {
        list: p => {
          p.tab = this.tabName;
          return getBillForecastList(p);
        },
        getConfig,
        getRemarkList,
        addRemark,
        exportExcel,
        delRemark,
        syncData
      },
      config: {
        height: 630,
        rowId: "id"
      },
      modals: {
        remarksList: {
          config: {
            listFn: "getRemarkList",
            isNoPage: true,
            modalBind: {
              width: 600
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            buttons: {
              bind: {
                style: {
                  display: "flex",
                  "justify-content": "flex-end",
                  "align-items": "center"
                }
              }
            }
          },
          footer: {
            show: false
          },
          grid: [{ remarks: 24 }],
          buttons: [
            {
              name: () => this.$t("addTo") + this.$t("order_desc"),
              id: 948,
              bind: {
                type: "primary",
                style: {
                  margin: 0,
                  marginBottom: "20px"
                }
              },
              disabled: ({ formData }) => {
                return !formData["remarks"];
              },
              methods: {
                click({ row }) {
                  this.$page
                    .handleRequestMethods("addRemark", {
                      id: row.id,
                      remarks: row.remarks
                    })
                    .then(res => {
                      this.$modal.$refs["form"].clear();
                      this.$modal.getList();
                      this.$page.getList();
                    });
                }
              }
            }
          ],
          fields: [
            {
              key: "remarks",
              name: () => this.$t("order_desc"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("order_desc");
              },
              id: 948,
              bind: {
                type: "textarea",
                autosize: { minRows: 3, maxRows: 6 }
              }
            }
          ],
          table: {
            config: {
              height: 500
            },
            fields: [
              {
                name: () => this.$t("operate"),
                key: "create_name"
              },
              {
                name: () => this.$t("operation") + this.$t("time"),
                key: "create_time"
              },
              {
                name: () => this.$t("order_desc"),
                key: "remarks"
              },
              {
                type: "btns",
                width: 150,
                name: () => this.$t("operation"),
                fixed: "right",
                // width({ field }) {
                //   return field.list.length * 40 + 40;
                // },
                list: [
                  {
                    name: () => this.$t("delete"),
                    type: "delete",
                    fnName: "delete",
                    // id: 160,
                    bind: {
                      type: "error"
                    }
                  }
                ],
                methods: {
                  delete({ row }) {
                    this.$Modal.confirm({
                      title: this.$t("delete"),
                      width: 300,
                      content: this.$t("titleModal"),
                      onOk: () => {
                        this.handleRequestMethods(
                          "delRemark",
                          row.id,
                          true,
                          true
                        ).then(res => {
                          this.getModal("remarksList").getList();
                          this.getList();
                        });
                      }
                    });
                  }
                }
              }
            ]
          },
          methods: {
            ok() {
              let obj = {
                name: this.$t("bagList"),
                fields: this.table.fields,
                data: this.list
              };
              this.$page.exportExc(obj);
            }
          }
        },
        remarks: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("addRemark", row, true)
                .then(res => {
                  console.log(this);
                  // this.getList();
                  close();
                });
            }
          },
          config: {
            rules: {
              remark: [
                {
                  required: true,
                  message: "remarks be empty",
                  trigger: "bulr"
                }
              ]
            },
            formBind: {
              labelWidth: 60
            },
            title: this.$t("add") + this.$t("order_desc"),
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          grid: [{ remark: 24 }],
          fields: [
            {
              key: "remark",
              name: () => this.$t("order_desc"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("order_desc");
              },
              bind: {
                type: "textarea",
                rows: 5
              }
            }
          ]
        }
      },
      header: {
        searchs: [
          {
            key: "dateType",
            placeholder() {
              return this.$t("select") + this.$t("date") + this.$t("type");
            },
            component: "Select",
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType(["EXTRACT_PREDICTION_SELECT"]))
                  .data.payload["EXTRACT_PREDICTION_SELECT"];
                field.options = res;
                searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              "on-change"({ searchForm }) {
                searchForm.startTime = searchForm.startTime
                  ? this.$page.format.timeFormat(searchForm.startTime)
                  : "";
              }
            }
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("end") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              "on-change"({ searchForm }) {
                let time = this.$page.format.timeFormat(searchForm.endTime);
                if (time.slice(-8) === "00:00:00") {
                  time = time.split(" ")[0] + " " + "23:59:59";
                  searchForm.endTime = time;
                }
              }
            }
          },
          {
            key: "status",
            component: "Select",
            bind: {
              style: "width:150px"
            },
            placeholder() {
              return this.$t("select") + this.$t("tip");
            },
            options: []
          },
          {
            key: "service_item",
            component: "Select",
            bind: {
              style: "width:150px"
            },
            placeholder() {
              return this.$t("select") + this.$t("deliveryCompany");
            },
            options: [],
            show: row => {
              return this.tabName != "KQ";
            }
          },
          {
            key: "keywordsType",
            placeholder() {
              return this.$t("select") + this.$t("keywords_type");
            },
            clearable: false,
            component: "Select",
            options: [],
            methods: {
              async list({ field, searchForm }) {
                let res = (await getSelectType("EXTRACT_PREDICTION_KEYWORDS"))
                  .data.payload['EXTRACT_PREDICTION_KEYWORDS'];
                field.options = res;
                searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              }
            }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              style: "width:140px",
              type: "textarea",
              rows: 1
            },
            component: "Input"
          }
        ],
        btns: {
          list: [
            {
              name: this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            },
            {
              name: this.$t("synchronous"),
              type: "synchronous",
              fnName: "synchronousFun",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "ios-refresh",
                type: "success"
              }
            }
          ],
          methods: {
            export() {
              let mawb = this.selectAll.map(item => item.mawb);
              this.handleRequestMethods(
                "list",
                {
                  export: 1,
                  mawb,
                  tab: that.tabName
                  // page: this.pageConfig.page,
                  // pageSize: this.pageConfig.size,
                  // ...this.$refs["header"].searchForm
                },
                true,
                true
              ).then(res => {
                window.open(this.$globalUrl + res.payload.src);
              });
            },
            synchronousFun() {
              let mawb = this.selectAll.map(item => item.mawb);
              this.handleRequestMethods(
                "syncData",
                {
                  mawb
                },
                true,
                true
              ).then(res => {
                this.getList();
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          fixed: "left",
          width: 60
        },
        {
          name: () => this.$t("mawb"),
          key: "mawb",
          align: "center",
          fixed: "left",
          width: 180,
          copy: true
        },
        {
          name: () => this.$t("CTNS"),
          key: "quantity",
          minWidth: 100
        },
        {
          name: () => this.$t("SHIPMENTS"),
          key: "order_total",
          minWidth: 100
        },
        {
          name: () => this.$t("country_t"),
          key: "country",
          minWidth: 100
        },
        {
          name: () => this.$t("clearance_agent1"),
          key: "clearance_agent",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          width: 130
        },
        {
          name: () => this.$t("DEPARTURE_TIME"),
          key: "depart_date",
          width: 130
        },

        {
          name: () => this.$t("ARRIVE_DATE"),
          key: "arrival_date",
          width: 130
        },
        {
          name: () => this.$t("clearance_date"),
          key: "clearance_date",
          width: 130
        },
        {
          name: () => this.$t("SERVICE_ITEM"),
          key: "service_item",
          minWidth: 100,
          showOverflow: false,
          type: "child",
          child: { list: "child" },
          show: () => this.tabName == "AE" 
        },
        {
          name: () => "B2B-" + this.$t("subPackage1"),
          key: "b2b_subpackage",
          rewriteKey: "b2b_subpackage1",
          minWidth: 100,
          show: () => this.tabName == "KQ"
        },
        // {
        //   name: () => "B2B-" + this.$t("subPackage1"),
        //   key: "b2b_subpackage",
        //   rewriteKey: "b2b_subpackage2",
        //   showOverflow: false,
        //   minWidth: 100,
        //   type: "child",
        //   child: { list: "child" },
        //   show: () => this.tabName == "SA"
        // },
        {
          name: () => this.$t("PACKAGE_CONCLUDED"),
          key: "package_concluded",
          minWidth: 100,
          show: () => this.tabName == "KQ"
        },
        {
          name: () => this.$t("INSIDE_PARCEL"),
          key: "inside_parcel",
          minWidth: 100,
          show: () => this.tabName == "KQ"
        },
        {
          name: () => this.$t("TOTAL_PARCEL"),
          key: "total_parcel",
          minWidth: 100,
          show: () => this.tabName == "KQ"
        },

        // {
        //   name: () => "B2B-" + this.$t("CTNS"),
        //   key: "b2b_ctns",
        //   minWidth: 100,
        //   showOverflow: false,
        //   type: "child",
        //   child: { list: "child" },
        //   show: () => this.tabName == "SA"
        // },
				{
          name: () => this.$t("RELATED_CTNS"),
          key: "related_ctns",
          minWidth: 100,
          showOverflow: false,
          type: "child",
          child: { list: "child" },
          show: () => this.tabName == "AE" 
        },
        {
          name: () => 'CNB' + this.$t("SHIPMENTS"),
          key: "related_cnbs",
          minWidth: 100,
          showOverflow: false,
          type: "child",
          child: { list: "child" },
          show: () => this.tabName == "AE" || this.tabName == "SA"
        },
        // {
        //   name: () => 'B2B' + this.$t("unpack") + this.$t("SHIPMENTS"),
        //   key: "b2b_subpackage",
        //   minWidth: 100,
        //   showOverflow: false,
        //   type: "child",
        //   child: { list: "child" },
        //   show: () => this.tabName == "SA"
        // },
        // {
        //   name: () => 'B2B' + this.$t("SHIPMENTS"),
        //   key: "b2b_ctns",
        //   minWidth: 100,
        //   showOverflow: false,
        //   type: "child",
        //   child: { list: "child" },
        //   show: () => this.tabName == "SA"
        // },
        {
          name: () => this.$t("REMARK"),
          key: "remarks",
          rewriteKey: "remarks1",
          minWidth: 120,
          component: ({ row }) => {
            return row.remarks ? "a" : "Button";
          },
          bind: {
            type: "success",
            size: "small"
          },
          show: () => this.tabName == "KQ" || this.tabName == "BH",
          id: 949,
          methods: {
            click({ row, parent }) {
              this.$page
                .getModal("remarksList")
                .open({ id: row.id }, function() {
                  this.setTitle(this.$t("REMARK"));
                  this.pageConfig.data["id"] = row.id;
                  this.getList();
                });
            },
            render({ row, value }) {
              return value ? value : this.$t("addTo");
            }
          }
        },
        {
          name: () => this.$t("REMARK"),
          key: "remarks",
          rewriteKey: "remarks2",
          minWidth: 120,
          showOverflow: false,
          type: "child",
          child: { list: "child", component: "Button" },
          bind: {
            type: "success",
            size: "small"
          },
          id: 949,
          show: () => this.tabName == "AE" || this.tabName == "SA",
          methods: {
            click({ row, parent }) {
              this.$page
                .getModal("remarksList")
                .open({ id: row.id }, function() {
                  this.setTitle(this.$t("REMARK"));
                  this.pageConfig.data["id"] = row.id;
                  this.getList();
                });
            },
            render({ value }) {
              return value ? value : this.$t("addTo");
            }
          }
        },
        {
          type: "btns",
          width: 100,
          name: () => this.$t("operation"),
          fixed: "right",
          btnBind: {
            type: "primary",
            size: "small"
          },
          btnName: () => this.$t("export"),
          down: true,
          list: [],
          methods: {
            exportFun({ field, row }) {
              this.handleRequestMethods(
                "exportExcel",
                {
                  type: field.type,
                  mawb: row.mawb
                },
                false,
                true
              ).then(res => {
                window.open(this.$globalUrl + res.payload.src);
              });
            }
          }
        }
      ]
    };
  },
  methods: {
    getExportList() {
      this.fields[this.fields.length - 1]["list"] = [];
      for (const key in this.setData.export[this.tabName]) {
        this.fields[this.fields.length - 1]["list"].push({
          name: this.setData.export[this.tabName][key],
          type: key,
          fnName: "exportFun",
          bind: {
            type: "success"
          }
        });
      }
      this.header.searchs.forEach(async item => {
        if (item.key === "service_item")
          item.options = this.setData.service_item[this.tabName];
      });
    },

    // tab切换
    handleTab() {
      this.getExportList();
      this.$refs["table"].pageConfig.page = 1;
      this.$refs["table"].pageConfig.size = 15;
      this.$refs["table"].resize();
      this.$refs["table"].getList();
      this.$refs["table"].getTable().recalculate(true);
    }
  },
  async mounted() {
    this.setData = (await getConfig()).data.payload;
    this.tabList = this.setData.tab;
    this.header.searchs.forEach(async item => {
      if (item.key === "service_item")
        item.options = this.setData.service_item[this.tabName];
      if (item.key === "status") {
        item.options = this.setData.status;
      }
    });
    this.getExportList();
  }
};
</script>
